import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid';
import { AssignAssessmentModalComponent } from 'app/assign-assessment-modal/assign-assessment-modal.component';
import { Globals } from 'app/globals';
import { PurchaseAssessmentModalComponent } from 'app/purchase-assessment-modal/purchase-assessment-modal.component';
import { CoachClientDto, CoachService } from 'app/services/coach/CoachService';
import { ToastrService } from 'ngx-toastr';
import { isNull } from 'util';
import { DuplicateEmailsManager } from '../../shared/manager/duplicate-emails-manager';
import { ImportClientsValidatorManager } from '../../shared/manager/import-clients-validator-manager';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-active-clients',
  templateUrl: './active-clients.component.html',
  styleUrls: ['./active-clients.component.scss']
})
export class ActiveClientsComponent implements OnInit {
    @Output() showTableChange = new EventEmitter<boolean>();

    @ViewChild('purchaseAssessment', { static: false}) public purchaseAssessmentModal: PurchaseAssessmentModalComponent;
    @ViewChild('assignAssessment', { static: false }) public assignAssessmentModal: AssignAssessmentModalComponent;

    @Output() openAssignModal = new EventEmitter<any>();


    public tags = [];
    public showFilterFields = false;
    public fields: string[] = ['Email', 'FirstName', 'LastName', 'Status'];
    public filters = [
    {
        text: 'Contains',
        value: 'contains'
    },
    {
        text: 'Equals',
        value: 'equals'
    },
    {
        text: 'Not Equals',
        value: 'notEquals'
    },
    {
        text: 'Starts With',
        value: 'startsWith'
    },
    {
        text: 'Ends With',
        value: 'endsWith'
    },
    {
        text: 'Not Contain',
        value: 'notContain'
    },
    {
        text: 'Not Start With',
        value: 'notStartWith'
    }
    ];
    public canDelete = false;
    public canAssign = false;
    public action = 'Add';
    public gridOptions: GridOptions;
    public clientsHeaders: any[];
    public assessmentsHeaders: any[] = [];
    public clients: any[] = [];
    public overlayNoRowsTemplate: any;
    public rowSelection: any = 'multiple';
    public fileName = '';
    public blobFile: any = null;
    private importFileText: string = null;
    private importFileBase64: string = null;
    public okImportClientsButton = 'Ok';
    public returnedClients: string[] = [];
    public showTable = false;
    public returnModalMessage = '';
    public gridApi: any;
    public placeholder = 'Enter tag';
    public clientTags = new Array<any>();
    public coachTags = new Array<any>();
    public coachTagsGridApi: any;
    public selectedCoachTags = new Array<any>();
    public coachTagsHeaders = new Array<any>();
    public addTags = new Array<any>();
    public auxAddTags = new Array<any>();
    public rowCount: number;

    private userFilters: any[] = [];
    private fromAgGridFilter = false;
    private rowCountData: any;
    private assessmentsELIData: any[] = [];
    private assessments360Data: any[] = [];
    private currentClientId: number;
    private clientsToDelete: number[] = [];
    private clientsToArchive: Array<number> = [];
    private clientEliTags = [];
    private selectedRow: any;
    private isFromManageTabs = false;
    private selectedClients = new Array<any>();

    constructor(
        private toastr: ToastrService,
        private coachService: CoachService,
        public _Globals: Globals,
        private router: Router
    ) {
        this.overlayNoRowsTemplate = '<span>No row to show</span>';
    }

  ngOnInit() {
    this.gridOptions = <GridOptions>{};
    this.gridOptions.rowHeight = 45;
    this.gridOptions.headerHeight = 40;
    // this.assessmentsGridOptions = <GridOptions>{};
    // this.assessmentsGridOptions.rowHeight = 45;
    // this.assessmentsGridOptions.headerHeight = 40;

    this.clientsHeaders = this.createHeaders();
    this.assessmentsHeaders = this.createAssessmentsHeaders()

    this.GetCoachClients();
    this.getCoachAvailableAssessmentsByType(1);
    this.getCoachAvailableAssessmentsByType(2);
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    console.log(event);
    this.showFilterFields = false;
  }

  public removeTag(index: number): void {
    const filter = this.tags[index].split(' ');
    console.log(filter);

    // remove the filter
    const filterComponent = this.gridApi.getFilterInstance(filter[0]);
    filterComponent.setModel(null);
    this.gridApi.onFilterChanged();

    // removing the filter from list
    this.tags.splice(index, 1);
    this.userFilters.splice(index, 1);
    console.log(this.tags);

    let filter2: any;
    let condition2: any;
    const pos = this.userFilters.map(function (e) { return e.field; }).indexOf(filter[0]);
    if (pos !== -1) {
        filter2 = this.userFilters[pos].filter;
        condition2 = this.userFilters[pos].condition;
        this.excecuteFilter(filter[0], filter2, condition2);
    }
    console.log(this.userFilters);
  }

  public removeCoachTag(index: number): void {
    const tagText = this.selectedCoachTags[index].Text;

    this.coachTagsGridApi.forEachNode((node) => {
        console.log(node);
        if (tagText === node.data.Text) {
            node.setSelected(false);
        }
    });

    this.selectedCoachTags.splice(index, 1);
  }

  public applyFilter(field: string, filter: string, condition: string): void {
    // let field = $('#field').val();
    // let filter = $('#filter').val();
    // let condition = $('#condition1').val();

    if (field === '' || filter === '' || condition === '') {
        this.toastr.warning('Empty fields', 'ELI');
        return;
    }

    console.log('field', field);
    console.log('filter', filter);
    console.log('value', condition);

    let filter2: any;
    let condition2: any;
    let multipleConditions = false;
    const pos = this.userFilters.map(function (e) { return e.field; }).indexOf(field);
    if (pos !== -1) {
        filter2 = this.userFilters[pos].filter;
        condition2 = this.userFilters[pos].condition;
        multipleConditions = true;
    }

    const newObj = {
        field: field,
        filter: filter,
        condition: condition
    }

    const contains = this.containsObject(newObj, this.userFilters);
    if (!contains) {
        this.userFilters.push(newObj);
        console.log(this.userFilters);

        const amount = this.getNumberOfConditionsByColumn(this.userFilters, field);
        if (amount <= 2) {
            this.tags.push(field + ' ' + filter + ' ' + condition);
            console.log(this.tags);
            this.showFilterFields = false;

            if (multipleConditions) {
                this.applyMultipleFilter(field, filter, condition, filter2, condition2);
            } else {
                if (!this.fromAgGridFilter) {
                    this.excecuteFilter(field, filter, condition);
                }
            }
        } else {
            this.userFilters.pop();
            this.toastr.warning('We are sorry. Conditions are limited to 2 per field.', 'ELI');
        }
    } else {
        console.log('already exist');
    }
  }

  public toggleFilter(): void {
    this.showFilterFields = true;
    this.fromAgGridFilter = false;
  }

  public filterChanged(e: any): void {
    this.fromAgGridFilter = true;
    console.log(e.api.filterManager.allFilters);

    const allFilters = e.api.filterManager.allFilters;
    const filterKeys = Object.keys(e.api.filterManager.allFilters);

    filterKeys.forEach((item) => {
        if (!isNull(allFilters[item].filterPromise.resolution.filterText)) {
            console.log(item);
            console.log(allFilters[item].filterPromise.resolution.filter);
            console.log(allFilters[item].filterPromise.resolution.filterText);
            this.applyFilter(item, allFilters[item].filterPromise.resolution.filter, allFilters[item].filterPromise.resolution.filterText);
        }
    })
  }

  public onGridReady(params: any): void {
    this.gridApi = params.api;
    this.sizeToFit(this.gridApi);
    setTimeout(() => {
        $('.ag-floating-filter-input').attr('placeholder', 'Filter');
    }, 100);
  }

  public onSelectionChangedChoiceSet(event: any): void {
    console.log('onSelectionChanged ', event);
    this.rowCount = event.api.getSelectedNodes().length;
    this.selectedClients = event.api.getSelectedNodes();
    if (this.rowCount === 1) {
        this.selectedRow = event.api.getSelectedNodes()[0].data;
    }
    this.rowCountData = this.getSelectedRows(this.gridApi);
    console.log('selection changed, ', this.rowCount + ' rows selected');

    if (this.rowCount >= 1) {
        this.canDelete = true;
        this.canAssign = true;
    } else {
        this.canDelete = false;
        this.canAssign = false;
    }
  }

  public archiveClients(): void {
    this.coachService.postArchiveCoachClients(this.clientsToArchive)
        .subscribe((data: any) => {
            console.log('response_ArchiveCoachClients', data);
            if (this._Globals.validationToken(data.result.Result)) {

                const _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.clientsToArchive = [];

                if (data.result.Result === 1) {
                    this.toastr.success('Clients archived successfully.', 'ELI');
                    this.GetCoachClients();
                    $('#archiveClientsModal').modal('hide');
                    this.deselectAllCheckBox(this.gridApi);
                } else {
                    // display a modal
                    this.returnedClients = _data;
                    console.log('returnedClients', this.returnedClients);
                    this.openReturnedModal('The following clients could not be archived');
                }
            }
    });
  }

  public openConfirmationModal(): void {
    const clientsToDelete = this.getSelectedRows(this.gridApi);
    if (Number(clientsToDelete.length) !== 0) {
        $('#clientConfirmationDeleteModal').modal({ backdrop: 'static' });
        $('#clientConfirmationDeleteModal').modal('show');
    }
  }

  public openArchiveModal(): void {
    const selectedRows = this.getSelectedRows(this.gridApi);
    if (Number(selectedRows.length) !== 0) {
        $('#archiveClientsModal').modal({ backdrop: 'static' });
        $('#archiveClientsModal').modal('show');
    }
  }

  public showAddClientModal(): void {
    $('#cemail').val('');
    this.action = 'Add';
    $('#caddClientModal').modal('show');
  }

  public closeModal(): void {
    $('#caddClientModal').modal('hide');
    $('#cname').val('');
    $('#clast').val('');
  }

  public onRowClicked(e) {
    console.log(e);
    if (e.event.target !== undefined) {
        const data = e.data;

        this.router.navigate(['/app/edit_clients', data['ClientId'], data['Email'], data['FirstName'], data['LastName'], data['Status']]);
        // this.editClientModal(data["Email"], data['ClientId'], data["FirstName"], data["LastName"]);
        // switch (e.event.target.id) {
        //    case "person":
        //        {
        //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
        //            this.edit(data['Id'], data['Text']);
        //            break;
        //        }

        //    case "deleteAction":
        //        {
        //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
        //            this.delete();
        //            break;
        //        }
        //    case "assingAction":
        //        {
        //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
        //            //this.edit(data['Id'], data['Text']);
        //            this.openAssignAssessmentModal(data['ClientId']);
        //            break;
        //        }
        // }
    }
  }

  public filterModified(e: any) {
    console.log(e.api.filterManager.allFilters);

    // let allFilters = e.api.filterManager.allFilters;
    // let filterKeys = Object.keys(e.api.filterManager.allFilters);

    // filterKeys.forEach((item) => {
    //    if (!isNull(allFilters[item].filterPromise.resolution.filterText)) {
    //        console.log(item);

    //        let count = this.getNumberOfConditionsByColumn(this.userFilters, item);
    //        if (count == 2) {
    //            console.log('disable button to apply for', item);
    //            $('#applyButton').prop('disabled', true).css("cursor", "not-allowed");
    //            console.log(this.userFilters);

    //            var newArray = this.userFilters.filter(function (f) {
    //                return f.field === item;
    //            });
    //            console.log(newArray);
    //            let text = newArray[1].condition;
    //            $('#filterText').val(text);

    //        } else {
    //            $('#applyButton').prop('disabled', false).css("cursor", "default");
    //        }
    //    }
    // });
  }

  public showImportModal(): void {
    $('#importClientsModal').modal('show');
    this.okImportClientsButton = 'Ok';
  }

  public preventSpace(value: string, event: any, id: string): any {
    if (value == null || value === '') {
        if (Number(event.keyCode) === 32) {
            return false;
        }
    }
    if (value === ' ') {
        $('#' + id + '').val('');
    }
  }

  public addClient(email: string, name: string, last: string): void {

    if (String(this.action) === 'Edit') {

        const clientId = this.currentClientId;

        console.log('Client edited');
        this.updateClient(clientId, name, last, email);
        return;
    }

    console.log('email', email);
    $('body').css('cursor', 'wait');

    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const validEmail = regex.test(email);
    console.log('Valid', validEmail)
    if (validEmail) {
        if (String(name) !== '' || String(last) !== '') {
            this.saveCoachClient(email, name, last);
        } else {
            this.toastr.warning('Please complete all the fields.', 'ELI');
            $('body').css('cursor', 'default');
        }

    } else {
        this.toastr.warning('Please enter a valid email address', 'ELI');
        $('body').css('cursor', 'default');
    }
  }

  public closeImportModal(): void {
    $('#importClientsModal').modal('hide');
    this.clearImportFile();
    $('#assignAssessments').prop('checked', false);
    this._Globals.assignAssessmentsForImportClients = false;
  }

  private clearImportFile(): void {
    $('#iFile').val('');
    this.fileName = '';
    this.blobFile = null;
    this.importFileText = null;
    this.importFileBase64 = null;
  }

  // Reads the file when it is selected, so a later change to the file on disk can't break (or hang) the import
  private readImportFile(file: any): void {
    this.importFileText = null;
    this.importFileBase64 = null;
    if (!file) { return; }

    const textReader = new FileReader();
    textReader.onload = () => {
        if (this.blobFile === file) { this.importFileText = textReader.result as string; }
    };
    textReader.onerror = (error) => this.onImportFileReadError(file, error);
    textReader.readAsText(file);

    const base64Reader = new FileReader();
    base64Reader.onload = () => {
        if (this.blobFile === file) { this.importFileBase64 = (base64Reader.result as string).split(',')[1]; }
    };
    base64Reader.onerror = (error) => this.onImportFileReadError(file, error);
    base64Reader.readAsDataURL(file);
  }

  private onImportFileReadError(file: any, error: any): void {
    console.log('Error: ', error);
    if (this.blobFile !== file) { return; } // another file was selected meanwhile
    this.toastr.error('We are sorry. The file could not be read. Please select the file again.', 'ELI');
    this.clearImportFile();
  }

  public downloadImportClientsTemplate(): void {
    const name = ImportClientsValidatorManager.templateFileName;
    const data = ImportClientsValidatorManager.templateContent;

    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(new Blob([data], { type: 'text/csv' }), name);
        return;
    }

    const a = $('<a style=\'display: none;\'/>');
    const url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
    a.attr('href', url);
    a.attr('download', name);
    $('body').append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  public getBlobFile(event: any): void {
    console.log(event);
    let file = event.srcElement.value;
    console.log(file);
    const str = String.raw`\fakepath`;
    file = file.split(str);
    file = file[1].substring(1);
    this.fileName = file;

    this._Globals.fileInputEvent = event;
    this.blobFile = event.target.files[0];
    this.readImportFile(this.blobFile);
    // var reader = new FileReader();
    // reader.addEventListener('load', this.readFile);
    // reader.readAsText(file);

    // var reader = new FileReader();
    // reader.readAsDataURL(file);
    // reader.onloadend = function () {
    //    var base64data = reader.result;
    //    console.log(base64data);
    // }
  }

  public assignAssessmentsStatus(): void {
    this._Globals.assignAssessmentsForImportClients = !this._Globals.assignAssessmentsForImportClients;
    console.log('assignAssessmentsForImportClients', this._Globals.assignAssessmentsForImportClients);
    !this._Globals.assignAssessmentsForImportClients ? this.okImportClientsButton = 'Ok' : this.okImportClientsButton = 'Next';
  }

  public okImportClients(): void {
    if (this.blobFile == null) {
        this.toastr.warning('Please select an a .csv file.', 'ELI');
    } else if (this.importFileText == null || this.importFileBase64 == null) {
        this.toastr.warning('The file is still loading. Please try again in a moment.', 'ELI');
    } else {
        $('body').css('cursor', 'wait');
        this.processImportFile();
    }
  }

  public closeModalReturned(): void {
    $('#returnedModal').modal('hide');
    this.closeModalConfirmation();
    this.clientsToDelete = [];
    this.deselectAllCheckBox(this.gridApi);
  }

  public delete(): void {
    const clientsToDelete = this.getSelectedRows(this.gridApi);
    console.log(clientsToDelete);

    clientsToDelete.forEach((client: any) => {
        this.clientsToDelete.push(client.ClientId);
    });

    this.deleteClients();
  }

  public archive(): void {
    this.clientsToArchive = this.getSelectedRows(this.gridApi).map((client: any) => client.ClientId);

    this.archiveClients();
  }

  // ----QUICK MENU-----

  /*Purchase Modal*/
  openPurchaseModal() {
    // this._Globals.purchaseFromHome = true;
    this.purchaseAssessmentModal.show(this);
  }

  ///*Assign Modal*/
  //openAssignModal() {
  //    this.assignAssessmentModal.showAssignModal(this, 1);
    //}

  public onItemRemoved(e: any, isFromManageTags = false): void {
    console.log('onItemRemoved', e);

    if (isFromManageTags) {
        let _index = this.addTags.indexOf(e);
        if (_index !== -1) {
            this.addTags.splice(_index, 1);
        }
        _index = this.auxAddTags.indexOf(e);
        if (_index !== -1) {
            this.auxAddTags.splice(_index, 1);
        }

        let tagText: string
            if (e.value) {
                tagText = e.value;
            } else {
                tagText = e;
            }

        this.coachService.postRemoveClientTag(this.selectedRow.ClientId, tagText)
                .subscribe((response: any) => {
                    if (this._Globals.validationToken(response.result.Result)) {
                        if (Number(response.result.Result) === 1) {
                            this.toastr.success('Tag removed successfully', 'ELI');
                        } else {
                            this.toastr.error('We are sorry, unexpected error removing the tag', 'ELI');
                        }
                    }
                },
                (err) => {
                    this.toastr.error('We are sorry, unexpected error removing the tag', 'ELI');
                });

        return;
    }

    const index = this.clientEliTags.indexOf(e.value);
    if (index !== -1) { this.clientEliTags.splice(index, 1); }
    console.log(this.clientEliTags);

    if (this.clientEliTags.length > 0) {
        this.getActiveClientsByTag(this.clientEliTags);
    } else {
        this.GetCoachClients();
    }
}

  public onItemAdded(e: any, isFromManageTabs = false): void {
    console.log('onItemAdded', e);

    if (isFromManageTabs) {
        // create array to set values to insert into db
        // remove values from previous array
        this.auxAddTags.push(e);
        return;
    }

    this.clientEliTags.push(e.value);
    console.log(this.clientEliTags);
    this.getActiveClientsByTag(this.clientEliTags);
  }

  public onFocusInput(): void {
    console.log('onFocusInput');
    setTimeout(() => {
        $('.ng2-tag-input--focused').css('border-bottom', '2px solid skyblue');
    }, 100);
  }

  public focusTagsInput(id: string): void {
    $('#' + id).focus();
  }

  public openTagsModal(isFromManageTabs = false): void {
    this.isFromManageTabs = isFromManageTabs;

    $('#coachTagsModal').modal({ backdrop: 'static' });
    $('#coachTagsModal').modal('show');
    this.coachTagsHeaders = this.createCoachTagsHeaders();
    this.getCoachTags();
    this.sizeToFit(this.coachTagsGridApi);

    setTimeout(() => {
        $('.ag-floating-filter-input').attr('placeholder', 'Filter');
    }, 100);
  }

  public onCoachTagsGridReady(params: any): void {
    this.coachTagsGridApi = params.api;
        setTimeout(() => {
            $('.ag-floating-filter-input').attr('placeholder', 'Filter');
        }, 100);
  }

  public onCoachTagsRowClicked(e: any) {
    console.log(e);
  }

  public onCoachTagsSelectionChanged(event: any) {
    console.log('onCoachTagsSelectionChanged ', event);

    const rowCount = event.api.getSelectedNodes().length;
    console.log('selection changed, ', rowCount + ' rows selected');

    this.selectedCoachTags = this.getSelectedRows(this.coachTagsGridApi);
    console.log('selectedCoachTags', this.selectedCoachTags);
}

public addNewCoachTags(): void {
    if (this.isFromManageTabs) {
        this.getSelectedRows(this.coachTagsGridApi).forEach((row: any) => {
            if (!this.auxAddTags.find(x => x.value === row.Text)) {
                const tag = { display: row.Text, value: row.Text };
                this.addTags.push(tag);
                this.auxAddTags.push(tag);
            }
        });
    } else {
        this.selectedCoachTags.forEach((item) => {
            if (!this.clientTags.find(x => x.value === item.Text)) {
                const tag = { display: item.Text, value: item.Text };
                this.clientTags.push(tag);
                this.onItemAdded(tag);
            }
        });
    }

    this.closeTagsModal();
}

public openAddTagsAssessmentsModal(): void {
    console.log('openAddTagsAssessmentsModal');

    if (this.rowCount !== 1) {
        $('#clientAddTagsModal').modal({ backdrop: 'static' });
        $('#clientAddTagsModal').modal('show');
        return;
    }

    this.coachService.getClientTags(this.selectedRow.ClientId)
        .subscribe((response: any) => {
            if (this._Globals.validationToken(response.result.Result)) {
                if (Number(response.result.Result) === 1) {
                    this.addTags = JSON.parse(response.result.Data).map((t: any) => { return {display: t.Text, value: t.Text}; });
                    $('#clientAddTagsModal').modal({ backdrop: 'static' });
                    $('#clientAddTagsModal').modal('show');
                } else {
                    this.toastr.error('We are sorry. An error occurred while trying to get client tags.', 'ELI');
                }
            }
        },
        (err) => {
            this.toastr.error('We are sorry. An error occurred while trying to get client tags.', 'ELI');
        });
}

public closeAddTagsModal(): void {
    $('#clientAddTagsModal').modal('hide');
    // this.assessmentAddTags = [];
    this.addTags = [];
    this.auxAddTags = [];
}

public addClientTags(): void {
    const clientsIds = this.selectedClients.map(client => Number(client.data.ClientId));
    this.coachService.postSaveClientTags(clientsIds, this.auxAddTags.map(tag => tag.value))
        .subscribe((response: any) => {
            if (this._Globals.validationToken(response.result.Result)) {
                if (Number(response.result.Result) === 1) {
                    this.toastr.success('Tag(s) added successfully', 'ELI');
                } else {
                    this.toastr.error('We are sorry, unexpected error adding the tag(s)', 'ELI');
                }
            }
        },
        (err) => {
            this.toastr.error('We are sorry, unexpected error adding the tag(s)', 'ELI');
        })

    this.closeAddTagsModal();
}

private createCoachTagsHeaders(): Array<any> {
    const columnDefs = new Array();

    const nameHeader = {
        headerName: 'Tag',
        field: 'Text',
        minWidth: 200,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellRenderer: function (params) {
            return params.value;
        }
    };
    columnDefs.push(nameHeader);


    return columnDefs;
}

  private excecuteFilter(field: any, filter: any, condition: any): void {
    const filterComponent = this.gridApi.getFilterInstance(field);
    filterComponent.setModel({
        type: filter,
        filter: condition
    });
    this.gridApi.onFilterChanged();
  }

  private applyMultipleFilter(field: any, filter: any, condition1: any, filter2: any, condition2: any): void {

    console.log('field', field);
    console.log('filter', filter);
    console.log('value', condition1);
    const operator = 'AND';
    console.log('filter2', filter2);
    console.log('value2', condition2);

    const sportsFilterComponent = this.gridApi.getFilterInstance(field);
    sportsFilterComponent.setModel({
        condition1: {
            type: filter,
            filter: condition1
        },
        condition2: {
            type: filter2,
            filter: condition2
        },
        operator: operator
    });
    this.gridApi.onFilterChanged();

    // this.tags.push(field + " " + filter + " " + condition1 + " " + operator + " " + filter2 + " " + condition2);
    console.log(this.tags);
    this.showFilterFields = false;
  }

  private containsObject(obj: any, list: any): boolean {
    let i: number;
    for (i = 0; i < list.length; i++) {
        if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
            return true;
        }
    }
    return false;
  }

  private getNumberOfConditionsByColumn(array: any[], field: any): number {
    let total = 0;
    for (let i = 0; i < array.length; i++) {
        if (array[i].field === field) {
            total++;
        }
    }
    return total;
  }

  private sizeToFit(gridApi: any): void {
    if (gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }
  }

  public getSelectedRows(gridApi): any {
    console.log('SELECTED', this.gridApi.getSelectedRows());
    return gridApi.getSelectedRows();
  }

  public deselectAllCheckBox(gridApi: any): void {
    this.canDelete = false;
    this.canAssign = false;
    gridApi.forEachNode(function (node) {
        node.setSelected(false);
    });
  }

  public GetCoachClients(): void {
    this.coachService.getCoachClients().subscribe((data: any) => {
        console.log('response_GetCoachClients', data);
        if (this._Globals.validationToken(data.result.Result)) {
            const _data = JSON.parse(data.result.Data);
            console.log('_data', _data);

            this.rowCount = 0;
            this.canDelete = false;
            this.clients = [];
            setTimeout(() => {
                this.clients = _data;
                this.showTable = true;
                this.showTableChange.emit(true);
            }, 250);

        }
    });
  }

  public getDisplayingTagsCount(): number {
    const tags = $('[ng-reflect-input-id=clientTagsInput] > .ng2-tag-input > .ng2-tags-container > tag');

    return tags.length;
  }

  public getCoachClientsFilteringByTag(): void {
    const tags = $('[ng-reflect-input-id=clientTagsInput] > .ng2-tag-input > .ng2-tags-container > tag');
    for (let count = 0; count < tags.length; count++) {
        const tagText = tags[count].children[0].children[0].innerText.trim();
        this.addTags.push({ display: tagText, value: tagText });
    }

    if (tags.length > 0) {
        this.getActiveClientsByTag(this.clientEliTags);
        this.showTable = true;
        this.showTableChange.emit(true);
    }
  }

  public closeTagsModal(): void {
    $('#coachTagsModal').modal('hide');
        this.selectedCoachTags = [];
  }

  private updateClient(clientId: number, firstName: string, lastName: string, email: string): void {
    if (String(firstName) === '' || String(lastName) === '') {
        this.toastr.warning('Please complete all the fields.', 'ELI');
        return;
    }

    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const validEmail = regex.test(email);
    console.log('Valid', validEmail)
    if (validEmail) {
        const coachClient = new CoachClientDto;
        coachClient.ClientId = clientId;
        coachClient.FirstName = firstName;
        coachClient.LastName = lastName;
        coachClient.Email = email;

        this.coachService.postUpdateClient(coachClient).subscribe(data => {
            console.log('response_postUpdateClient', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result === 1) {
                    this.toastr.success('Client updated successfully.', 'ELI');
                    this.GetCoachClients();
                    this.closeModal();
                    return;
                }

                if (data.result.Result === -1) {
                    this.toastr.error('Client info cannot be updated since the entered email address is currently in use by another user', 'ELI');
                } else {
                    this.toastr.error('An error happen, please try again.', 'ELI');
                }
            }
        });
    }
  }

  createHeaders() {
    const columnDefs = new Array();

    // let actionsHeader = {
    //    headerName: 'Actions',
    //    field: '',
    //    minWidth: 85,
    //    width:85,
    //    suppressSizeToFit: true,
    //    suppressSorting: true,
    //    suppressMenu: true,
    //    cellRenderer: function (params) {
    //        let content = '';

    //        //content += '<i id="person" class="material-icons custom-icons">person_pin</i>';

    //        //console.log('params', params);
    //        if (params.data.Status == 1) {
    //            content += '<i id="assingAction" class="material-icons custom-icons">person</i>';
    //        }

    //        content += '<i id="deleteAction" class="material-icons custom-icons">delete</i>';

    //        return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

    //    }
    // };
    // columnDefs.push(actionsHeader);

    // let checkHeader = {
    //    headerName: '',
    //    field: '',

    //    minWidth: 30,
    //    width: 30,
    //    suppressSizeToFit: false,
    //    cellRenderer: function (params) {
    //        return '';
    //    }
    // };
    // columnDefs.push(checkHeader);

    const emailHeader = {
        headerName: 'Email',
        field: 'Email',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        filterParams: {
            apply: true
        },
        minWidth: 200,
        width: 200,
        suppressSizeToFit: false,
        cellRenderer: function (params) {
            return params.value;
        }
    };
    columnDefs.push(emailHeader);

    const nameHeader = {
        headerName: 'First Name',
        field: 'FirstName',
        filterParams: {
            suppressAndOrCondition: true,
            apply: true
        },
        minWidth: 200,
        width: 200,
        suppressSizeToFit: false,
        cellRenderer: function (params) {
            return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
        }
    };
    columnDefs.push(nameHeader);

    const lastNameHeader = {
        headerName: 'Last Name',
        field: 'LastName',
        filterParams: {
            apply: true
        },
        minWidth: 200,
        width: 200,
        suppressSizeToFit: false,
        cellRenderer: function (params) {
            return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
        }
    };
    columnDefs.push(lastNameHeader);

    const statusHeader = {
        headerName: 'Status',
        field: 'Status',
        filterParams: {
            apply: true
        },
        minWidth: 200,
        width: 200,
        suppressSizeToFit: false,
        cellRenderer: function (params) {
            return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
        }
    };
    columnDefs.push(statusHeader);

    // const assessmentStatusHeader = {
    //     headerName: 'Assessment Status',
    //     field: 'AssessmentStatus',
    //     filterParams: {
    //         apply: true
    //     },
    //     minWidth: 200,
    //     width: 200,
    //     suppressSizeToFit: false,
    //     cellRenderer: function (params) {
    //         return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
    //     }
    // };
    // columnDefs.push(assessmentStatusHeader);

    return columnDefs;
  }

  private createAssessmentsHeaders(): any[] {
    const columnDefs = new Array();

    const nameHeader = {
        headerName: 'Name',
        field: 'AssessmentName',
        minWidth: 200,
        width: 200,
        suppressSizeToFit: false,
        cellRenderer: function (params) {
            return params.value;
        }
    };
    columnDefs.push(nameHeader);

    const quantityHeader = {
        headerName: 'Quantity',
        field: 'Amount',
        minWidth: 120,
        width: 120,
        suppressSizeToFit: true,
        cellRenderer: function (params) {
            return params.value;
        }
    };
    columnDefs.push(quantityHeader);

    return columnDefs;
  }

  private getCoachAvailableAssessmentsByType(assessmentType: number): void {
    this.coachService.getCoachAvailableAssessmentsByType(assessmentType).subscribe((data: any) => {
        console.log('response_GetRaters', data);
        if (this._Globals.validationToken(data.result.Result)) {
            const _data = JSON.parse(data.result.Data);
            console.log('_data', _data);

            if (assessmentType === 1) {
                this.assessmentsELIData = _data;
            } else {
                this.assessments360Data = _data;
            }

        }

    });
  }

  private editClientModal(email: string, clientId: number, name: string, last: string): void {
    $('#cemail').val(email);
    this.currentClientId = clientId;
    $('#cname').val(name);
    $('#clast').val(last);
    this.action = 'Edit';
    $('#caddClientModal').modal('show');
  }

  private saveCoachClient(email: string, name: string, last: string) {
    this.coachService.postSaveCoachClient(email, name, last).subscribe(data => {
        console.log('response_PostSaveCoachClient', data.result);
        if (this._Globals.validationToken(data.result.Result)) {
            if (Number(data.result.Result) === 1) {
                this.GetCoachClients();
                this.closeModal();
                this.toastr.success('Client added successfully', 'ELI');
                $('body').css('cursor', 'default');
            } else {
                this.toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
            }
        }

    });
    }

  private processImportFile(): void {
      const csvContent = this.importFileText;
      const base64file = this.importFileBase64;

      const errors = ImportClientsValidatorManager.findErrors(csvContent);

      if (errors.length > 0) {
          console.warn('Invalid import file:', errors);
          this.toastr.warning(`The file contains invalid data: \n${errors.slice(0, 5).join('\n')}${errors.length > 5 ? `\n...and ${errors.length - 5} more` : ''}`, 'ELI');
          this.clearImportFile();
          $('body').css('cursor', 'default');
          return; // stop the process
      }

      const duplicates = DuplicateEmailsManager.findDuplicateEmails(csvContent);


      if (duplicates.length > 0) {
          console.warn('Emails duplicados encontrados:', duplicates);
          this.toastr.warning(`We found duplicate emails: \n${duplicates.join(', ')}`, 'ELI');
          this.clearImportFile();
          $('body').css('cursor', 'default');
          return; // stop the process
      }

      // not duplicates, continue
      console.log('Base64 file', base64file);

      if (!this._Globals.assignAssessmentsForImportClients) {
          this.importClients(base64file);
      } else {
          console.log('assessmentsELIData', this.assessmentsELIData);
          this._Globals.base64ImportFile = base64file;
          $('body').css('cursor', 'default');
          //this.assignAssessmentModal.assignAssessmentNewModal.show(
          //    this,
          //    false,
          //    this.assessmentsELIData[0].is360,
          //    this.assessmentsELIData[0].Amount,
          //    this.assessmentsELIData[0].AssessmentName,
          //    this.assessmentsELIData[0].AssessmentId,
          //    undefined);

          this.openAssignModal.emit({
              context: this,
              is360: this.assessmentsELIData[0].Is360,
              amount: this.assessmentsELIData[0].Amount,
              assessmentName: this.assessmentsELIData[0].AssessmentName,
              assessmentId: this.assessmentsELIData[0].AssessmentId,
          });
      }
  }

  private importClients(base64file: string): void {
    this.coachService.postImportClients(base64file).subscribe((data: any) => {
        console.log('response_PostImportClients', data);
        if (this._Globals.validationToken(data.result.Result)) {
            const _data = JSON.parse(data.result.Data);
            console.log('_PostImportClients data', _data);

            switch (data.result.Result) {
                case -5:
                    this.toastr.error('We are sorry. The specified file does not include any valid client. Please check that the First Names and Last Names values only include alphanumeric characters and that the the email addresses are valid.', 'ELI');
                    break;

                case -4:
                    this.toastr.error('Some clients could not be imported. We sent you an email with the details about the import process.', 'ELI');
                    break;

                case -3:
                    this.toastr.error('Invalid file format. Please be sure that you included the \'Email\', \'First Name\' and \'Last Name\' columns. Please notice that headers names are case sensitive.', 'ELI');
                    break;

                case -2:
                    this.toastr.error('We are sorry. You don\'t have enough available assessments for the number of clients included in the file.', 'ELI');
                    break;

                case 0:
                    this.toastr.error('We are sorry. An unexpected error happened while trying to import the clients.', 'ELI');
                    break;

                case 1:
                    this.toastr.success('Clients imported successfully.', 'ELI');
                    this.GetCoachClients();
                    break;
            }

            this.closeImportModal();
            $('body').css('cursor', 'default');
        }
    });
  }

  private closeModalConfirmation(): void {
    $('#clientConfirmationDeleteModal').modal('hide');
  }

  private deleteClients(): void {
    this.coachService.postDeleteClients(this.clientsToDelete).subscribe((data: any) => {
        console.log('response_deleteClients', data);
        if (this._Globals.validationToken(data.result.Result)) {

            const _data = JSON.parse(data.result.Data);
            console.log('_data', _data);

            this.clientsToDelete = [];

            if (data.result.Result === 1) {
                this.toastr.success('Clients deleted successfully.', 'ELI');
                this.GetCoachClients();
                this.closeModalConfirmation();
                this.deselectAllCheckBox(this.gridApi);
            } else {
                // display a modal
                this.returnedClients = _data;
                console.log('returnedClients', this.returnedClients);
                this.openReturnedModal(
                    'The following clients could not be removed because either ' +
                    'they have pending assessments or they are assigned as raters for other clients'
                    );
            }

        }
    });
  }

  private openReturnedModal(message: string): void {
    $('#returnedModal').modal({ backdrop: 'static' });
    $('#returnedModal').modal('show');
    this.returnModalMessage = message;
  }

  private getCoachTags() {
    this.coachService.getCoachTags().subscribe((data: any) => {
        console.log('getCoachTags data', data);
        if (this._Globals.validationToken(data.result.Result)) {
            const _data = JSON.parse(data.result.Data);
            console.log('response_GetCoachTags', _data);
            this.coachTags = _data;
        }
    });
 }

 private getActiveClientsByTag(tags: Array<any>): void {
    this.coachService.GetCoachClientByTag(tags)
        .subscribe((response: any) => {
            console.log('getActiveClientsByTag data', response);

            if (this._Globals.validationToken(response.result.Result)) {
                const _data = JSON.parse(response.result.Data);
                console.log('response_GetCoachTags', _data);
                this.rowCount = 0;
                this.canDelete = false;
                this.clients = _data;
            }
        },
        (err) => {
            this.toastr.error('We are sorry. An unexpected error happened while trying to get clients filtering by tags.', 'ELI')
        },
        () => {

        });
 }
}
